import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Modal } from '@calendly/ui/components/modal';
import { Sheet } from '@calendly/ui/components/sheet';
import { HeadingText, BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useRestoreContactMutation } from 'features/contacts/api';
const modalContainerCss = "mu01jfl";
const ModalContainer = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(modalContainerCss, props.className)} />);
const contentCss = "c1wu1lyk";
const Content = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentCss, props.className)} />;
});
const headerCss = "hfn9wd7";
const Header = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerCss, props.className)} />;
});
const footerCss = "fhyuy8n";
const Footer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerCss, props.className)} />;
});
const buttonStylingCss = "b16pkusx";
const ButtonStyling = forwardRef((props, ref) => <Button ref={ref} {...props} className={classNames(buttonStylingCss, props.className)} />);
export const RestoreContactModal = ({
  isModalOpen,
  onClose,
  uuid,
  name
}) => {
  const [restoreContact] = useRestoreContactMutation();
  const handleRestoreButton = () => {
    const updateParams = {
      contact: {
        uuid,
        visible: true
      }
    };
    restoreContact(updateParams);
    onClose();
  };
  return <Modal isOpen={isModalOpen} onClose={onClose}>
      <ModalContainer>
        <Content>
          <Header>
            <HeadingText level={2}>
              {I18n.t('publisher.contacts.restore_contact_modal.header', {
              name
            })}
            </HeadingText>
          </Header>
          <BodyText>
            {I18n.t('publisher.contacts.restore_contact_modal.message')}
          </BodyText>
          <Footer>
            <ButtonStyling decoration="secondary-outline" onClick={onClose}>
              {I18n.t('publisher.contacts.restore_contact_modal.cancel')}
            </ButtonStyling>
            <ButtonStyling onClick={handleRestoreButton}>
              {' '}
              {I18n.t('publisher.contacts.restore_contact_modal.restore')}
              {' '}
            </ButtonStyling>
          </Footer>
        </Content>
      </ModalContainer>
    </Modal>;
};

require("./restore_contact_modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./restore_contact_modal.js");